export const TwoLines = ({ primary, secondary }) => (
  <div className="whitespace-nowrap">
    <div className="font-medium text-theme-headings dark:text-themedark-headings">{primary || '—'}</div>
    {secondary && (
      <div className="text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">{secondary}</div>
    )}
  </div>
);

const StoreCell = ({ store }) => <TwoLines primary={store?.name} secondary={store?.account_number} />;

export default StoreCell;
